var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$context.is.buyNow || _vm.$context.is.basic2pro)?_c('VideoSDKSuccess'):_c('success',{attrs:{"show-promotes":false}},[_c('thanks',{attrs:{"email":_vm.email,"title":_vm.title}},[_c('view-account')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }